import { BaseObject } from './BaseObject';
import { SVGRenderer } from '../core/SVGRenderer';
import { Point2D } from '../types';

export class Segment extends BaseObject {
  public p1: Point2D;
  public p2: Point2D;
  public isConstruction: boolean;
  public lineElem: SVGLineElement | null = null;
  public drawProgress: number = 1.0;

  constructor(
    renderer: SVGRenderer,
    p1: Point2D,
    p2: Point2D,
    isConstruction: boolean = false,
    id?: string
  ) {
    super(renderer, id);
    this.p1 = { ...p1 };
    this.p2 = { ...p2 };
    this.isConstruction = isConstruction;
    this.color = isConstruction ? renderer.config.constructionColor : renderer.config.lineColor;
    this.strokeWidth = isConstruction ? 2.0 : 3.0;
    this.render();
  }

  public render(): SVGElement {
    this.lineElem = this.renderer.createElement('line', {
      id: this.id,
      x1: this.p1.x,
      y1: this.p1.y,
      x2: this.p1.x + (this.p2.x - this.p1.x) * this.drawProgress,
      y2: this.p1.y + (this.p2.y - this.p1.y) * this.drawProgress,
      stroke: this.color,
      'stroke-width': this.strokeWidth,
      'stroke-linecap': 'round',
    });

    if (this.isConstruction) {
      this.renderer.layers.constructions.appendChild(this.lineElem);
    } else {
      this.renderer.layers.objects.appendChild(this.lineElem);
    }

    this.element = this.lineElem;
    return this.lineElem;
  }

  public setDrawProgress(progress: number): void {
    this.drawProgress = Math.max(0, Math.min(1, progress));
    this.update();
  }

  public update(): void {
    if (!this.lineElem) return;

    const currentX2 = this.p1.x + (this.p2.x - this.p1.x) * this.drawProgress;
    const currentY2 = this.p1.y + (this.p2.y - this.p1.y) * this.drawProgress;

    this.lineElem.setAttribute('x1', String(this.p1.x));
    this.lineElem.setAttribute('y1', String(this.p1.y));
    this.lineElem.setAttribute('x2', String(currentX2));
    this.lineElem.setAttribute('y2', String(currentY2));
    this.lineElem.setAttribute('stroke', this.color);
  }

  public length(): number {
    return SVGRenderer.distance(this.p1, this.p2);
  }
}
